import { Feature } from '@turf/turf';
import { VehiclePosition } from './vehicle-position';

import * as turf from '@turf/turf';
import { VehicleDeviation } from './vehicle-deviation';
import { VehicleConfirmedWarning, VehicleWarning, WarningMessageType } from './vehicle-warning';
import { StateOfChargeMeasurementPoint } from './vehicle-state-of-charge-history';
import { CurrentAssignment } from './vehicle-current-assignment';

import * as _ from 'lodash';

export class Vehicle {
    inventoryNumber: string;
    inventoryNumberWithoutPrefix: string
    garageCode: string;
    position: VehiclePosition;
    arrivalDeviation: VehicleDeviation;
    departureDeviation: VehicleDeviation;
    warnings: VehicleWarning[];
    confirmedWarnings: VehicleConfirmedWarning[];
    routeNumber: string;
    blockNumber: string;
    tripNumber: string;
    trafficAreaName?: string;
    progressType: string;
    stateOfCharge?: StateOfChargeMeasurementPoint;
    currentAssignment?: CurrentAssignment;
    onVehicleTaskBlock: boolean;
    onTrip: boolean;
    trafficDate?: string;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);

            if (obj.position) {
                this.position = new VehiclePosition(obj.position);
            }

            this.setInventoryNumberWithoutPrefix()
        }
    }

    public setInventoryNumberWithoutPrefix() {
        if (this.inventoryNumber == undefined) {
            return;
        }

        // remove prefix for Norwegian and Finnish vehicles
        const charsToRemove = /\D/g;

        if (charsToRemove.test(this.inventoryNumber)) {
            this.inventoryNumberWithoutPrefix = this.inventoryNumber.replace(charsToRemove, '');
            return;
        }

        this.inventoryNumberWithoutPrefix = this.inventoryNumber;
    }

    public toFeature(isSelected: boolean = false): Feature {
        if (!this.position?.longitude || !this.position?.latitude) {
            return undefined;
        }

        const properties = {
            inventoryNumber: this.inventoryNumber,
            title: this.inventoryNumber.replace(/\D/g, ''), // replaces letters with empty-string. only keep numbers.
            bearing: this.position.bearing,
            zIndex: 0, // places early busses icons on top in the map.
            type: 'vehicle'
        };

        if (isSelected) {
            const selectionProperties = this._createSelectionProperties();
            Object.assign(properties, selectionProperties);
        }

        const feature = turf.point([this.position.longitude, this.position.latitude], properties);
        return feature;
    }

    public get lineId(): string {
        return `${this.routeNumber}.${this.trafficAreaName}`;
    }

    public get onTomLayOvr(): boolean {
        return (this.onVehicleTaskBlock && !this.onTrip);
    }

    public get isElectric(): boolean {
        return !(this.stateOfCharge == undefined || this.stateOfCharge === undefined);
    }

    public get displayableWarnings(): VehicleWarning[] {  
        if (!this.warnings) return [];
        return this.warnings.filter(w => {
            if (w.messageType !== WarningMessageType.SignOnMissingWarning) return true;
            return !!(this.routeNumber && this.tripNumber);
        });
    }

    private _createSelectionProperties(): any {
        const properties: any = {};
        properties.isSelected = true;
        properties.zIndex = 15;
        return properties;
    }
}
